import { useEffect, useState } from 'react';
import { useAuth } from '../../utils/Auth/AuthProvider';
import { useStudentResult, useStudentResultChapters, useStudentResults } from '../../react-query/queries';
import { useParams } from 'react-router-dom';
import {
    FolderIcon,
    BookOpenIcon,
    EyeIcon,
    NoSymbolIcon,
    CheckCircleIcon,
    XCircleIcon,
    AcademicCapIcon,
    QuestionMarkCircleIcon,
    CalendarIcon,
} from '@heroicons/react/20/solid'
import ReactApexChart from 'react-apexcharts';
import { Progress } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { ApexOptions } from "apexcharts";

const StudentExamTaken = () => {
    const { token } = useAuth();
    const { studId } = useParams();
    const [resultId, setResultId] = useState<number>(0);
    const [isResult, setIsResult] = useState<boolean>(false);
    const [chapSeries, setChapSeries] = useState<number[]>();
    const [labelSeries, setLabelSeries] = useState<string[]>();


    const { status: resultsStatus, data: resultsData, error: resultsError, isFetching: resultsIsFetching } = useStudentResults(token, studId)
    const { status: resultStatus, data: resultData, error: resultError, isFetching: resultIsFetching } = useStudentResult(token, studId, resultId, isResult)
    const { status: resultChapterStatus, data: resultChapterData, error: resultChapterError, isFetching: resultChapterIsFetching } = useStudentResultChapters(token, studId, resultId, isResult)

    var series: number[] = [];
    var label: string[] = [];

    const options: ApexOptions = {
        labels: labelSeries,

        chart: {
            type: 'donut',
            height: '100%',
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '50%',
                    background: 'transparent',
                },
            },
        },
        dataLabels: {
            enabled: false,
        },
        responsive: [
            {
                breakpoint: 2600,
                options: {
                    chart: {
                        width: '100%',
                    },
                },
            },
            {
                breakpoint: 640,
                options: {
                    chart: {
                        width: '100%',
                    },
                },
            },
        ],
        legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'left',

            itemMargin: {
                horizontal: 10
            }
        }
    }



    useEffect(() => {
        if (resultChapterData != null) {
            resultChapterData.forEach((element: { [x: string]: any; }) => {
                series.push(element['ques_no'])
                label.push(element['result_chapter'])
            });
            setChapSeries(series);
            setLabelSeries(label);
        }
    }, [isResult, resultChapterData]);

    return (

        <>
            {resultId == 0 ?
                <>
                    <div className="w-full bg-white px-5 pt-6 pb-2.5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5 xl:pb-1">
                        <div className="max-w-full overflow-x-auto">
                            <div className='content-center'>
                                {resultData == null ?
                                    <>
                                        <h2 className="text-xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
                                            Exams Taken
                                        </h2>
                                        <p className="text-sm font-medium">List of exams taken by this student</p>
                                    </>

                                    :
                                    ''
                                }

                            </div>
                            {resultsData != null ? resultsData.map((_res: any) => (
                                <>
                                    <div className="lg:flex lg:items-center lg:justify-between m-5 p-5 bg-green-50">
                                        <div className="min-w-0 flex-1">
                                            <div className='flex flex-row items-center'>
                                                <div>
                                                    <FolderIcon aria-hidden="true" className="mr-1.5 h-15 w-20 flex-shrink-0 text-blue-900" />
                                                </div>
                                                <div>
                                                    <h2 className="text-xl font-bold  text-gray-900 sm:truncate sm:text-xl sm:tracking-tight">
                                                        {_res['exam_name']}
                                                    </h2>
                                                </div>
                                            </div>


                                            <div className="mt-1 p-5 flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap sm:space-x-6">
                                                <div className="mt-2 flex items-center text-sm text-gray-500">
                                                    <BookOpenIcon aria-hidden="true" className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" />
                                                    {_res['exam_subject']}
                                                </div>
                                                <div className="mt-2 flex items-center text-sm text-gray-500">
                                                    <AcademicCapIcon aria-hidden="true" className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" />
                                                    Grade {_res['exam_grade']}
                                                </div>
                                                <div className="mt-2 flex items-center text-sm text-gray-500">
                                                    <CalendarIcon aria-hidden="true" className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" />
                                                    Taken on {_res['exam_created']}
                                                </div>
                                            </div>
                                            <div className="mt-1 px-5 flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap sm:space-x-6">

                                                <div className="mt-2 flex items-center text-sm text-gray-500">
                                                    <QuestionMarkCircleIcon aria-hidden="true" className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" />
                                                    {_res['tot_ques']} Total Questions
                                                </div>
                                                <div className="mt-2 flex items-center text-sm text-gray-500">
                                                    <CheckCircleIcon aria-hidden="true" className="mr-1.5 h-5 w-5 flex-shrink-0 text-green-700" />
                                                    <span className='text-green-700'>{_res['exam_right']}</span>
                                                </div>
                                                <div className="mt-2 flex items-center text-sm text-gray-500">
                                                    <XCircleIcon aria-hidden="true" className="mr-1.5 h-5 w-5 flex-shrink-0 text-red-700" />
                                                    <span className='text-red-700'>{_res['exam_wrong']}</span>
                                                </div>
                                                <div className="mt-2 flex items-center text-sm text-gray-500">
                                                    <NoSymbolIcon aria-hidden="true" className="mr-1.5 h-5 w-5 flex-shrink-0 text-blue-700" />
                                                    <span className='text-blue-700'>{_res['tot_ques'] - (_res['exam_right'] + _res['exam_wrong'])}</span>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="mt-5 flex lg:ml-4 lg:mt-0">
                                            <span className="sm:ml-3">
                                                <button
                                                    type="button"
                                                    className="inline-flex items-center rounded-md bg-indigo-600 px-5 py-3 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                                    onClick={(e) => { setResultId(_res['id']); setIsResult(true); }}
                                                >
                                                    <EyeIcon aria-hidden="true" className="-ml-0.5 mr-1.5 h-5 w-5" />
                                                    View
                                                </button>
                                            </span>

                                        </div>
                                    </div>
                                </>
                            )) : ''}
                        </div>
                        <br /><br /><br />
                    </div>
                </>

                :

                <div className="">

                    {resultData != null ?
                        <>
                            <div className="relative max-lg:row-start-1">
                                <div className="absolute inset-px rounded-lg bg-white"></div>
                                <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] max-lg:rounded-t-[calc(2rem+1px)]">
                                    <div className="px-8 sm:px-10 sm:pt-8">
                                        <p className="text-xl font-medium tracking-tight text-gray-900 max-lg:text-center">
                                            {resultData['exam_name']}
                                        </p>
                                        <p className="mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center">
                                            Exam Statistics
                                        </p>
                                    </div>
                                    <div className="flex justify-evenly">
                                        <div className='col-span-6'>
                                            <ReactApexChart
                                                options={
                                                    {
                                                        chart: {
                                                            height: 350,
                                                            type: 'radialBar',
                                                        },
                                                        series: [(resultData['exam_right'] * 100 / resultData['tot_ques'])],
                                                        labels: ['Result'],
                                                    }
                                                }
                                                series={[(resultData['exam_right'] * 100 / resultData['tot_ques'])]}
                                                type="radialBar"
                                                height={400}
                                            />
                                        </div>
                                        <div className='col-span-6 px-10 self-center'>
                                            <div className='grid grid-cols-4'>
                                                <div className='col-span-3'>
                                                    They have got {resultData['exam_right']} questions right.
                                                </div>
                                                <div className='col-span-1 justify-self-end'>
                                                    20%
                                                </div>
                                            </div>
                                            <Progress.Line percent={(resultData['exam_right'] * 100 / resultData['tot_ques'])} showInfo={false} status='success' />
                                            <br />
                                            <div className='grid grid-cols-4'>
                                                <div className='col-span-3'>
                                                    They have got {resultData['exam_wrong']} questions wrong.
                                                </div>
                                                <div className='col-span-1 justify-self-end'>
                                                    20%
                                                </div>
                                            </div>
                                            <Progress.Line percent={(resultData['exam_wrong'] * 100 / resultData['tot_ques'])} showInfo={false} status='fail' />
                                            <br />
                                            <div className='grid grid-cols-4'>
                                                <div className='col-span-3'>
                                                    {resultData['tot_ques'] - (resultData['exam_right'] + resultData['exam_wrong'])} Questions Unanswered
                                                </div>
                                                <div className='col-span-1 justify-self-end'>
                                                    20%
                                                </div>
                                            </div>
                                            <Progress.Line percent={((resultData['tot_ques'] - (resultData['exam_right'] + resultData['exam_wrong'])) * 100 / resultData['tot_ques'])} showInfo={false} />
                                        </div>


                                    </div>
                                </div>
                                <div className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 max-lg:rounded-t-[2rem]"></div>
                            </div>
                            <br />
                            <div className="w-full bg-white px-5 pt-6 pb-2.5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5 xl:pb-1">
                                <div className="max-w-full overflow-x-auto">
                                    <div className="">
                                        <p className="text-3xl font-bold tracking-tight text-gray-800 font-bold">
                                            Chapter Analysis
                                        </p>
                                    </div>
                                    <br />
                                </div>
                            </div>
                            <br />
                            <div className='grid grid-cols-2 gap-5'>
                                <div className='col-span-1'>
                                    <div className="w-full bg-white px-5 pt-6 pb-2.5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5 xl:pb-1">
                                        <div className="">
                                            <p className="text-xl font-medium tracking-tight text-gray-800 font-bold">
                                                Analysis of Results by Chapter
                                            </p>
                                        </div>
                                        <br /> <br />
                                        {resultChapterData != null ? resultChapterData.map((_chap: any) => (
                                            <div className='grid grid-cols-12'>
                                                <div className='col-span-1'></div>
                                                <div className='col-span-10'>
                                                    <div className='grid grid-cols-4'>
                                                        <div className='col-span-3 font-bold'>
                                                            {_chap['result_chapter']}
                                                        </div>
                                                        <div className='col-span-1 justify-self-end'>
                                                            {(_chap['right'] * 100 / _chap['ques_no']).toFixed(1)} %
                                                        </div>
                                                    </div>
                                                    <Progress.Line percent={(_chap['right'] * 100 / _chap['ques_no'])} showInfo={false} />
                                                    <div className='grid grid-rows-2'>
                                                        <div className='px-4 bg-blue-mine font-bold'>
                                                            Scored {_chap['right']}/{_chap['ques_no']}
                                                        </div>
                                                        <div className='px-4 bg-blue-mine font-bold'>
                                                            Avg. time per question: {_chap['avg_time']} s
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-span-1'></div>
                                                <br />
                                                <br />
                                            </div>
                                        ))
                                            : ''}

                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                    </div>
                                </div>
                                <div className='col-span-1'>
                                    <div className="w-full bg-white px-5 pt-6 pb-2.5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5 xl:pb-1">
                                        <div className="max-w-full overflow-x-auto">
                                            <div className="">
                                                <p className="text-xl font-medium tracking-tight text-gray-800 font-bold">
                                                    Exam composition by chapter
                                                </p>
                                            </div>
                                        </div>
                                        <br /><br />
                                        <ReactApexChart options={options} series={chapSeries} type="donut" height={600} />

                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                    </div>
                                </div>
                            </div>

                            
                        </>

                        :
                        ''
                    }
                </div>
            }




            <br />

            <br />
        </>
    )
}

export default StudentExamTaken